module.exports = __webpack_public_path__ + "assets/1ac082296849a73d8d0427f7250af1a0.png";